import { createContext, useContext } from 'react';
import type { HelperDelegation } from '../../../services/round-delegations';
import type { StoredDelegation } from './storage';

/**
 * The helper's phone a round page is open on, when it is (RoundHelperGate):
 * the delegation as the server last described it, and where this phone's pages
 * live. Null on every other page — which is how the round pages tell a helper
 * from whoever is signed in.
 */
export interface RoundDelegationValue {
  stored: StoredDelegation;
  delegation: HelperDelegation;
  /** `/competitions/:slug/rounds/:roundId/aiuto/:token` — every page of this phone is under it. */
  basePath: string;
}

export const RoundDelegationContext = createContext<RoundDelegationValue | null>(null);

export function useRoundDelegation(): RoundDelegationValue | null {
  return useContext(RoundDelegationContext);
}
